export enum HighlightedBlockComponentImageFit {
	COVER = 'cover',
	CONTAIN = 'contain',
	FILL = 'fill',
	NONE = 'none'
}
